package linkerpangoquipdb

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class CommonFlagsQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun selectFlag(id: String): Query<Boolean> = SelectFlagQuery(id) { cursor ->
    cursor.getBoolean(0)!!
  }

  public fun <T : Any> selectCompleteFlag(id: String, mapper: (
    id: String,
    value_: Boolean,
    last_update: Long,
  ) -> T): Query<T> = SelectCompleteFlagQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getBoolean(1)!!,
      cursor.getLong(2)!!
    )
  }

  public fun selectCompleteFlag(id: String): Query<Common_flags> = selectCompleteFlag(id, ::Common_flags)

  public fun <T : Any> selectAllFlags(mapper: (
    id: String,
    value_: Boolean,
    last_update: Long,
  ) -> T): Query<T> = Query(865_840_825, arrayOf("common_flags"), driver, "CommonFlags.sq", "selectAllFlags", "SELECT common_flags.id, common_flags.value, common_flags.last_update FROM common_flags") { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getBoolean(1)!!,
      cursor.getLong(2)!!
    )
  }

  public fun selectAllFlags(): Query<Common_flags> = selectAllFlags(::Common_flags)

  public fun selectLastUpdateAt(): Query<Long> = Query(-1_950_572_699, arrayOf("common_flags"), driver, "CommonFlags.sq", "selectLastUpdateAt", "SELECT last_update FROM common_flags ORDER BY last_update DESC LIMIT 1") { cursor ->
    cursor.getLong(0)!!
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertFlag(
    id: String,
    value_: Boolean,
    last_update: Long,
  ): Long {
    val result = driver.execute(1_431_590_268, """INSERT INTO common_flags (id, value, last_update) VALUES (?, ?, ?)""", 3) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindBoolean(parameterIndex++, value_)
          bindLong(parameterIndex++, last_update)
        }.await()
    notifyQueries(1_431_590_268) { emit ->
      emit("common_flags")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteFlag(id: String): Long {
    val result = driver.execute(-2_064_953_490, """DELETE FROM common_flags WHERE id = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
        }.await()
    notifyQueries(-2_064_953_490) { emit ->
      emit("common_flags")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAllFlags(): Long {
    val result = driver.execute(-2_139_430_808, """DELETE FROM common_flags""", 0).await()
    notifyQueries(-2_139_430_808) { emit ->
      emit("common_flags")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateFlag(
    value_: Boolean,
    last_update: Long,
    id: String,
  ): Long {
    val result = driver.execute(169_493_388, """UPDATE common_flags SET value = ?, last_update = ? WHERE id = ?""", 3) {
          var parameterIndex = 0
          bindBoolean(parameterIndex++, value_)
          bindLong(parameterIndex++, last_update)
          bindString(parameterIndex++, id)
        }.await()
    notifyQueries(169_493_388) { emit ->
      emit("common_flags")
    }
    return result
  }

  private inner class SelectFlagQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("common_flags", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("common_flags", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-1_190_531_521, """SELECT value FROM common_flags WHERE id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, id)
    }

    override fun toString(): String = "CommonFlags.sq:selectFlag"
  }

  private inner class SelectCompleteFlagQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("common_flags", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("common_flags", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-1_963_144_168, """SELECT common_flags.id, common_flags.value, common_flags.last_update FROM common_flags WHERE id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, id)
    }

    override fun toString(): String = "CommonFlags.sq:selectCompleteFlag"
  }
}
